import React, { useState } from "react";

export const Context = React.createContext({});

const neverChnagesForDemo = {
  address: "123 Somwhereville",
  customerName: "John Doe",
  designImage:
    "https://proposalimages2.s3.amazonaws.com/batterydesign/Your+Design.png",
  finalCost: 12800.69,
  finanncingCost: 100,
  initialProposal: true,
  installCost: 10546.6,
  oppnum: "MS123456",
  productCost: 2155,
  salesrepEmail: "JBerg",
};

export const statesWithInfo = [
  {
    ...neverChnagesForDemo,
    city: "Playa Del Ray",
    state: "CA",
    zip: "90291",
  },
  { ...neverChnagesForDemo, city: "Stafford", state: "CT", zip: "06075" },
  {
    ...neverChnagesForDemo,
    city: "Winter Haven",
    state: "FL",
    zip: "00019",
  },
  { ...neverChnagesForDemo, city: "Shartlesville", state: "PA", zip: "19554" },
  { ...neverChnagesForDemo, city: "Bloomfield", state: "NJ", zip: "07003" },
  { ...neverChnagesForDemo, city: "Dobbs Ferry", state: "NY", zip: "10522" },
  { ...neverChnagesForDemo, city: "Klondike", state: "TX", zip: "75448" },
];

const ContextProvider = ({ children }) => {
  const [stateIndex, setStateIndex] = useState(2);

  //const states = ["CA", "CT", "FL", "PA", "NJ", "NY", "TX"];

  const [info, setInfo] = useState(
    statesWithInfo[stateIndex]
    // address: "123 Somwhereville",
    // city: "Winter Haven",
    // customerName: "John Doe",
    // designImage:
    //   "https://proposalimages2.s3.amazonaws.com/batterydesign/Your+Design.png",
    // finalCost: 12800.69,
    // finanncingCost: 100,
    // initialProposal: true,
    // installCost: 10546.6,
    // oppnum: "MS123456",
    // productCost: 2155,
    // salesrepEmail: "JBerg",
    // state: "FL",
    // zip: "00019",
  );

  const [usState, setUsState] = useState("NJ");

  return (
    <Context.Provider
      value={{
        info,
        setInfo,
        usState,
        setUsState,
        stateIndex,
        setStateIndex,
      }}
    >
      {children}
    </Context.Provider>
  );
};
export default ContextProvider;
